import styled from '@emotion/styled';

export const Menu = styled.div`
    height: calc(100% - ${({ theme }) => theme.header.height + 1}rem);
    overflow-y: auto;
    overflow-x: hidden;
`;
